import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { PopularTopicsBox } from "../help_support/components/PopularTopicsBox";
import { InnerSearch } from "../components/search/InnerSearch";
import NoResultsfound from "../../../assets/VZY/No_Results_found.svg";
import chatIcon from "../../../assets/VZY/result-not-found.png";
import { ChatBot } from "../components/chatBot/ChatBot";
const innerSearch = {
  pageName: "Search Results for",
  backSteps: "",
  breadcrumb: [
    {
      label: "Home",
      url: "/VZYSupport/helpSupport",
    },
    { label: "No Results found !" },
  ],
};

export const NoResultsFound = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  const [popularTopic, setPopularTopic] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const FetchPopularTopicList = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const payload = {
        contentTypeID: 3,
        categoryID: 0,
        isActive: 0,
        pageNumber: 1,
        pageSize: 6,
      };
      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchPopularTopicCategory`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      setPopularTopic(response?.data?.result?.popularTopicsList ?? []);
    } catch (err) {
      console.error("FetchSelfHelpVideoList error:", err);
      setError("Failed to load videos. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    FetchPopularTopicList();
  }, [FetchPopularTopicList, apiBaseURL]);
  return (
    <>
      <InnerSearch innerSearch={innerSearch} />

      <section className="inner-page-details">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="result-not-found">
                <h4>No Results found !</h4>
                <img src={NoResultsfound} alt="No Results found !" />
                <h5>Cannot find a solution ?</h5>
                <span
                  className="no-result-btn"
                  onClick={() => setIsChatBotOpen(true)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={chatIcon} alt="chat" />
                  Chat with us
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vzy-common-box">
        <div className="container">
          <h1 className="title-Heading" style={{ textAlign: "left" }}>
            Browse Popular Topics
          </h1>
          <div className="popular-topics-row">
            <PopularTopicsBox popularTopic={popularTopic} />
          </div>
        </div>
      </section>

      <ChatBot isOpen={isChatBotOpen} onClose={() => setIsChatBotOpen(false)} />
    </>
  );
};
